import { createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import { postInquiry, postCustomerInquiry, postForm } from '../services/FormsService';

export const useFormsPostInquiry = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(postInquiry, 'requestBody', 'data'),
      'data',
      'subject',
      'submittedText',
      'inquiryType',
      'attachments',
      'person',
      'budgetManager',
      'customerId',
    ),
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      {
        target: 'data',
        props: ['subject', 'submittedText', 'inquiryType', 'attachments', 'person', 'budgetManager', 'customerId'],
      },
    ],
  },
);

export const useFormsPostCustomerInquiry = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(postCustomerInquiry, 'requestBody', 'data'),
      'data',
      'subject',
      'submittedText',
      'inquiryType',
      'attachments',
      'person',
      'budgetManager',
      'customerId',
    ),
  ),
  {
    injectables: ['label', 'customerId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      {
        target: 'data',
        props: ['subject', 'submittedText', 'inquiryType', 'attachments', 'person', 'budgetManager', 'customerId'],
      },
    ],
  },
);

export const useFormsPostForm = createMutationHook(
  collapseParams(
    collapseParams(postForm, 'requestBody', 'data'),
    'data',
    'mailboxName',
    'urlOrigin',
    'initials',
    'surnamePreposition',
    'surname',
    'emailAddress',
    'street',
    'postalCode',
    'houseNumber',
    'houseNumberSuffix',
    'city',
    'formFields',
    'attachments',
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      {
        target: 'data',
        props: [
          'mailboxName',
          'urlOrigin',
          'initials',
          'surnamePreposition',
          'surname',
          'emailAddress',
          'street',
          'postalCode',
          'houseNumber',
          'houseNumberSuffix',
          'city',
          'formFields',
          'attachments',
        ],
      },
    ],
  },
);
